import { Trophy } from "lucide-react";

export default function PoweredByBadge() {
  return (
    <a
      href="/"
      data-testid="powered-by-badge"
      className="fixed bottom-4 right-4 z-30 flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0A4628] text-white shadow-lg hover:bg-[#0F5C36] transition-all duration-200 group no-print"
      style={{ fontSize: "11px" }}
      title="WSDK Connect — Plateforme de gestion des clubs sportifs"
    >
      <span className="w-5 h-5 rounded-full bg-[#FCD116] flex items-center justify-center shrink-0">
        <Trophy className="w-3 h-3 text-[#0A4628]" />
      </span>
      <span className="opacity-75 group-hover:opacity-100 transition">Propulsé par</span>
      <span className="font-display font-bold text-[#FCD116] tracking-wider">WSDK CONNECT</span>
    </a>
  );
}
